import { render } from "./AdicionarVeiculo.vue?vue&type=template&id=e635f812&scoped=true&ts=true"
import script from "./AdicionarVeiculo.vue?vue&type=script&lang=ts"
export * from "./AdicionarVeiculo.vue?vue&type=script&lang=ts"

import "./AdicionarVeiculo.vue?vue&type=style&index=0&id=e635f812&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e635f812"]])

export default __exports__